import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import styles from "./LoanRequest.module.scss";
import arrowLeft from "../../../../assets/web/arrow-left.svg";
import { appInsights } from "../../../../components/AppInsight/AppInsight";
import { MixPanel } from "../../../../helpers/mixpanel";
import { Button, Form, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  updateBorrowerDetailsAction,
  updateLoanDetailsAction,
  updateWebSettingsAction,
} from "../../../../redux/actions";
import { ReduxStoreModel } from "../../../../interfaces/redux-interface";
import { useHistory } from "react-router-dom";

interface LoanRequestProps {
  onPrevStep: () => void;
  setCurrentStep: Dispatch<SetStateAction<number>>;
}

interface FormValues {
  itemDescription: string;
  itemAmount: string;
}

function BNPLItemSelectionPage({
  onPrevStep,
  setCurrentStep,
}: LoanRequestProps) {
  const [form] = Form.useForm();
  const borrowerDetails = useSelector(
    (state: ReduxStoreModel) => state.borrowerDetailsReducer,
  );
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    appInsights.trackPageView({
      name: "Web  - (BNPLItemSelectionPage.tsx)",
      isLoggedIn: true,
    });

    MixPanel.track(`Page View: BNPLItemSelectionPage.tsx`, {
      page: "BNPLSummaryPage.tsx - (Web)",
    });
  }, []);

  const handlePreviousStep = () => {
    dispatch(
      updateWebSettingsAction({
        showLoanRequestModal: false,
        showLoanOptions: true,
      }),
    );
  };

  function onFinish(values: FormValues) {
    if (values.itemDescription && values.itemAmount) {
      const cleanedAmount = values.itemAmount.replace(/,/g, "");

      dispatch(
        updateBorrowerDetailsAction({
          itemDescription: values.itemDescription,
          itemAmount: cleanedAmount,
        }),
      );

      history.push(
        `/${borrowerDetails?.aggregator_name}/${values.itemDescription}/${cleanedAmount}`,
      );
      setCurrentStep(14);
    }
  }

  return (
    <div className={styles.bnpl_container}>
      <img
        src={arrowLeft}
        alt=""
        className={styles.arrow}
        onClick={handlePreviousStep}
      />
      <header className={styles.bnpl_item_selection_header}>
        <h3>Purchase Details</h3>
      </header>

      <Form form={form} layout="vertical" onFinish={onFinish} size="large">
        <Form.Item name="itemDescription" label="What do you want to buy?">
          <Input placeholder="e.g. toyota corolla 2016" />
        </Form.Item>
        <Form.Item
          name="itemAmount"
          label="Amount"
          style={{ marginTop: "10px" }}
          normalize={(value) =>
            value
              ? new Intl.NumberFormat("en-US").format(
                  Number(value.replace(/\D/g, "")),
                )
              : value
          }
        >
          <Input />
        </Form.Item>

        <Button htmlType="submit" className={styles.submit_button}>
          Proceed
        </Button>
      </Form>
    </div>
  );
}

export default BNPLItemSelectionPage;
